
import LpgBookingMainComp from "../../components/lpg-booking/LpgBookingMainComp"

export const LpgBookingPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <LpgBookingMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}